var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#99cc33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-building",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    x: 4,
    y: 2,
    rx: 2,
    ry: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22v-4h6v4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6h.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6h.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6h.01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10h.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14h.01"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10h.01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14h.01"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10h.01"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14h.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.f4a346a9d8a946b40ce34d01076f35bc.svg";
export { ForwardRef as ReactComponent };